import React from 'react';
import { isMobile } from 'react-device-detect';
import { useIsMobileDimensions } from '../../../shared/utils';
import { ArithmeglyphsStore } from '../../ArithmeglyphsStore';
import './GlyphReference.less';

const GlyphReference = () => {
  const isOpen = ArithmeglyphsStore.useState(s => s.glyphReferenceIsOpen);
  const useMobileDimensions = useIsMobileDimensions() || isMobile;
  const containerClasses =
    (useMobileDimensions ? 'mobileGlyphReference' : 'desktopGlyphReference')
    + (isOpen ? ' open' : '');

  return (
    <div className={containerClasses}>
      <button className="closeButton" onClick={() => {
        ArithmeglyphsStore.update(s => {
          s.glyphReferenceIsOpen = false;
        });
      }}>
        ×
      </button>
      <div className="referenceContentContainer">
        <div className="referenceHeader">
          Glyph Reference
        </div>
        <div className="scrollContainer">
          <ul className="referenceList">
            <li>
              <div className="itemLabel">No glyph</div>
              <div className="itemDescription">
                A digit with no glyph will be unchanged.
              </div>
            </li>
            <li>
              <div className="itemLabel">Triangle</div>
              <div className="itemDescription">
                A digit inside a triangle will be multipled by 3.
              </div>
            </li>
            <li>
              <div className="itemLabel">Diamond</div>
              <div className="itemDescription">
                A digit inside a diamond will be multiplied by 4.
              </div>
            </li>
            <li>
              <div className="itemLabel">Square</div>
              <div className="itemDescription">
                A digit inside a square will be squared.
              </div>
            </li>
            <li>
              <div className="itemLabel">Circle</div>
              <div className="itemDescription">
                A digit inside a circle will be rounded down to the next lowest even number. Examples: Circle(4) is 2; Circle(3) is also 2; Circle(2) is 0. A circle will never contain a zero.
              </div>
            </li>
            <li>
              <div className="itemLabel">Dot</div>
              <div className="itemDescription">
                A digit with a single dot over it will have 1 added to its value.
              </div>
            </li>
            <li>
              <div className="itemLabel">Blue rectangle</div>
              <div className="itemDescription">
                <p>When multiple glyphs are enclosed by a blue rectangle, the results of those glyphs will be added together before inserting the resulting digits on the next line.</p>
                <p>Note that resulting values of 10 and up are always broken into separate digits on the next line (i.e. 10 would become 1 and 0), but only after all operations take place.</p>
                <p>So a blue rectangle around two triangle(4)s plays out as:</p>
                <p>(3 × 4) + (3 × 4) = 24</p>
                <p>Thus, a 2 and a 4 would result on the next line.</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default GlyphReference;